/* eslint-disable max-len */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import '../../../UiComponents/SideNav/styles.css';
import { isTouchDevice } from '../../../libs/HelperContent';
import { useNavigate } from 'react-router-dom';
import { RiArrowRightSLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, AccordionDetails, AccordionSummary, Badge, Tab, Tabs, Tooltip } from '@mui/material';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { getTemplatesList } from '../../actions/contract_actions';
import { updateBadgeCount } from '../../../redux/NetworkRedux';
import Certification from '../../../assets/SideNavIcons/Certification.svg';
import Resources from '../../../assets/SideNavIcons/Resources.svg';
import Employees from '../../../assets/SideNavIcons/Employees.svg';
import Recognition from '../../../assets/SideNavIcons/Recognition.svg';
import Contracts from '../../../assets/SideNavIcons/Contracts-1.svg';
import Meetings from '../../../assets/SideNavIcons/Meeting.svg';
import Profile from '../../../assets/SideNavIcons/Profile.svg';
import Dashboard from '../../../assets/SideNavIcons/Dashboardsidenavicon.svg';
import Menu from '../../../assets/SideNavIcons/Menu.svg';
import Department from '../../../assets/SideNavIcons/Department.svg';
import Relation from '../../../assets/SideNavIcons/Relation.svg';
import ProductWarranty from '../../../assets/SideNavIcons/Product_Warrenty.svg';
import SocialMediaIntegration from '../../../assets/SideNavIcons/Social_Media_Integration.svg';
import NetworkIcon from '../../../assets/SideNavIcons/Network.svg';
import TaskIcon from '../../../assets/SideNavIcons/Task.svg';
import { HamburgerContext } from '../../../libs/Context';
import BusinessProfile from '../../../assets/SideNavIcons/businessprofile.svg';
import Collaboration from '../../../assets/SideNavIcons/Collaboration.svg';
import Trainingwebinar from '../../../assets/SideNavIcons/trainingwebinar.svg';
// import NewsfeedConfig from '../../../assets/SideNavIcons/newsfeedConfig.svg';
// import BusinessProfile from '../../../assets/SideNavIcons/businessprofile.svg';

const CustomSidenav = (props) =>
{
	const { hideSideNavInContent, setHideSideNavInContent } = props;
	const activePath = window.location.pathname.split('/')[2];
	const naviagte = useNavigate();
	const dispatch = useDispatch();
	const userData = useSelector((state:any) => state?.mysession?.session);
	const userConfigs = useSelector((state:any) => state?.mysession?.userConfigs);
	const updateContractLibBatchCount = useSelector((state: any) => state?.mynetwork?.badgeCount?.contractLibBadgeCount);
	const borderIndex = [ 6, 13 ];
	const currentSelectedRef = useRef<HTMLDivElement | null>(null);
	const isDashboardAdmin = userConfigs?.dashboardManagement?.isAdmin;

	const ManagementOptions:any = [
		...(isDashboardAdmin
			? [ {
				id         : '20',
				linkPath   : '/businessDashboard',
				srcPath    : Dashboard,
				svgPath    : '',
				title      : 'Dashboard',
				errSrcPath : 'profile.svg',
				role       : [ 'company', 'employee' ],
				empRole    : [ 'superAdmin', 'admin', 'employee' ]
			} ]
			: []),
		{
			id         : '0',
			linkPath   : '/businessProfile',
			srcPath    : Profile,
			svgPath    : '',
			title      : 'Profile',
			errSrcPath : 'profile.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin', 'admin', 'employee' ]
		},
		{
			id         : '13',
			linkPath   : '/employees',
			srcPath    : Employees,
			title      : 'Employees',
			errSrcPath : 'employees.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin', 'admin' ]
		},
		{
			id         : '24',
			linkPath   : '/analytics',
			srcPath    : Dashboard,
			title      : 'Analytics',
			errSrcPath : 'analytics.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin', 'admin' ]
		},
		{
			id         : '3',
			linkPath   : '/relation',
			srcPath    : Relation,
			title      : 'relations',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin', 'admin' ]

		},
		{
			id         : '14',
			linkPath   : '/recognition',
			srcPath    : Recognition,
			title      : 'Recognition',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin', 'admin' ]
		},
		{
			id         : '2',
			linkPath   : '/department',
			srcPath    : Department,
			title      : 'Role Access',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin', 'admin' ]

		},
		{
			id         : '1',
			linkPath   : '/menu',
			srcPath    : Menu,
			svgPath    : '',
			title      : 'Menu Access',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin' ]
		},
		{
			id         : '7',
			linkPath   : '/socialMediaIntegration',
			srcPath    : SocialMediaIntegration,
			title      : 'Social Media Access',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin' ]

		},
		{
			id         : '5',
			linkPath   : '/feedsconfiguration',
			srcPath    : SocialMediaIntegration,
			title      : 'Feeds',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin' ]

		},
		{
			id         : '12',
			linkPath   : '/content',
			srcPath    : Resources,
			title      : 'Content',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : userConfigs?.employeePermissions?.permissions?.view ? [ 'superAdmin', 'admin' ] : [ 'superAdmin' ]

		},
		{
			id         : '11',
			linkPath   : '/certificationManagement',
			srcPath    : Certification,
			title      : 'Certification',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin', 'admin' ]
		},
		{
			id         : '15',
			linkPath   : '/contractManagement', // #I2622 on clicking business setting direct route to socialmediaintegration not required
			srcPath    : Contracts,
			title      : 'Contracts',
			errSrcPath : 'setting.svg',
			role       : [ 'company' ],
			empRole    : [ 'superAdmin', 'admin' ]
		},
		{
			id         : '16',
			linkPath   : '/meetingManagement',
			srcPath    : Meetings,
			title      : 'Meetings',
			errSrcPath : 'setting.svg',
			role       : [ 'company' ],
			empRole    : [ 'superAdmin', 'admin' ]
		},
		{
			id         : '17',
			linkPath   : '/webinarManagement',
			srcPath    : Trainingwebinar,
			title      : 'Webinar',
			errSrcPath : 'setting.svg',
			role       : [ 'company' ],
			empRole    : [ 'superAdmin', 'admin' ]
		},
		{
			id         : '4',
			linkPath   : '/productWarranty',
			srcPath    : ProductWarranty,
			title      : 'Product warranty',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin' ]

		},
		{
			id         : '19',
			linkPath   : '/networksConfigure',
			srcPath    : NetworkIcon,
			title      : 'Networks',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin' ]
		}
		// {
		// 	id         : '18',
		// 	linkPath   : '/collaborationManageMent',
		// 	srcPath    : Collaboration,
		// 	title      : 'Collaboration',
		// 	errSrcPath : 'setting.svg',
		// 	role       : [ 'company' ],
		// 	empRole    : [ 'superAdmin', 'admin' ]
		// }
	];

	// console.log(hideSideNavInContent, '----------**');
	const handleNavigate = (linkPath:any) =>
	{
		// console.log(linkPath, '------------');
		naviagte(`/businessSettings${linkPath}`);
		setHideSideNavInContent(!hideSideNavInContent);
	};

	const getBadgeCount = async () =>
	{
		const query = '?type=badgeTemplateCount';
		const response = await getTemplatesList(query);

		if (response?.status)
		{
			dispatch(updateBadgeCount({ contractLibBadgeCount: response?.count }));
		}
		else
		{
			dispatch(updateBadgeCount({ contractLibBadgeCount: 0 }));
		}
	};

	const businessOptions = [
		{
			id         : '17',
			linkPath   : '/businessProfile',
			icon       : BusinessProfile,
			name       : 'Profile',
			errSrcPath : 'profile.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'superAdmin', 'admin', 'employee' ]
		}

	];

	useEffect(() =>
	{
		setHideSideNavInContent(activePath?.toLowerCase() === 'content');
	}, [ activePath ]);

	useEffect(() =>
	{
		const currentPath = window.location.pathname;
		const pathSegments = currentPath.split('/');

		// Check for template/contract editing patterns
		const isCreatingTemplate = currentPath.includes('/createNewTemplate/') && pathSegments.length > 3; // has id parameter
		const isEditingContract = currentPath.includes('/contractCreation/') && pathSegments.length > 2; // has id parameter
		const isViewingTemplate = currentPath.includes('/contractManagement/view/') && pathSegments.length > 4; // has templateId parameter
		const isDuplicatingTemplate = currentPath.includes('/duplicateTemplate/');

		const isEditMode = isCreatingTemplate || isEditingContract || isViewingTemplate || isDuplicatingTemplate;

		if (!isEditMode)
		{
			getBadgeCount();
		}
	}, []);

	useEffect(() =>
	{
		if (currentSelectedRef?.current)
		{
			currentSelectedRef.current.scrollIntoView({ block: 'center' });
		}
	}, [ currentSelectedRef ]);

	return (
		<>
			<div className='flexCol'>
				<div className='flexRow hideScrollX customSideNavMob pdngVXS'>
					{ManagementOptions?.map((each, index) =>
					{
						const activeNav =
                            activePath?.toLowerCase() === each.linkPath.split('/')[1]?.toLowerCase() ? 'invertPrimary' : 'invertGray';
						const activeText =
                            activePath?.toLowerCase() === each.linkPath.split('/')[1]?.toLowerCase() ? 'activeText' : '';
						const activeLink =
                            activePath?.toLowerCase() === each.linkPath.split('/')[1]?.toLowerCase() ? 'activeLinkBrdrNone' : '';

						return (
							each?.empRole?.includes(userData?.empRole) &&
							<div ref={activeLink ? currentSelectedRef : null} className={'flexInline pdngHXS'} key={`${each?.id}unq${index}`}> <div className={`flexInline resNavLinkCustom whiteBg brdrRadiusXSM ${activeLink}`} onClick={() => handleNavigate(each.linkPath)}>
								<div className='flexAutoRow pdngHXS'>
									<div className={`resNavIcons ${activeNav} flexInline jusifyCntr alignCntr`} >
										<img src={`${each.srcPath}`}/>
									</div>
								</div>
								<div className='flexMinWidthCol pointer pdngRSM '>
									<span className={`resNavLinkTxt ${activeText} ellipsisTxt capitalTxt`}>
										{each.title}
									</span>
								</div>
							</div>
							</div>
						);
					}
					)}
				</div>
			</div>
			<div className='flexCol whiteBg fullHeight customSideNavWeb'>
				{!hideSideNavInContent && <h2 className='mainHdngTxtside pdngHMD'>Manage Business</h2>}
				<div className='flexMinHeightCol scrollY'>
					<ul className={`flexMinHeightCol resSideNavGroup pdngBSM scrollXHidden ${isTouchDevice() ? 'scrollY' : 'scrollbarSideNav'}`}>
						<li className='flexCol resNavItem pointer'>
							{ManagementOptions?.map((each, index) =>
							{
								const isPathMatching = activePath?.toLowerCase() === each.linkPath.split('/')[1]?.toLowerCase();

								const activeNav = isPathMatching ? 'invertPrimary' : 'invertGray';
								const activeText = isPathMatching ? 'activeText' : '';
								const activeLink = isPathMatching ? 'activeLink' : '';

								return (
									each?.empRole?.includes(userData?.empRole) &&
									<div key={`${each?.id}unqK${index}`} ref={activeLink ? currentSelectedRef : null} className={`flexRow alignCntr resNavLink ${activeLink} ${borderIndex?.includes(index) ? 'brdrBSM' : ''}`} onClick={() => handleNavigate(each.linkPath)}>
										<div className='flexAutoRow pdngHXS'>
											<div className={`resNavIcons ${activeNav} flexInline jusifyCntr alignCntr`}>
												<img src={`${each.srcPath}`}/>
											</div>
										</div>
										{!hideSideNavInContent &&
										<><div className='flexMinWidthRow pointer pdngRSM'>
											<span className={`resNavLinkTxt ${activeText} ellipsisTxt capitalTxt`}>
												{each.title}
											</span>
										</div><div className='flexAutoRow'>
											{each.linkPath === '/contractManagement' && <Badge color='primary' variant='standard' badgeContent={updateContractLibBatchCount} />}
										</div><div className={`flexAutoRow pointer ${activeText}`}>
											<RiArrowRightSLine />
										</div></>}
									</div>
								);
							})}
						</li>
					</ul>
				</div>
			</div>
		</>

	);
};

export default CustomSidenav;